<template>
	<div class="Logo logo-block" v-on:click="goTop()" v-bind:class="{ hidden: isActive() }">
		<svg class="svg-logo" width="0" height="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 367.95 137" >
			<defs></defs>
			<title>Phantom Equipment</title>
			<g id="logo" data-name="logo">
				<polygon points="184.02 130.54 213.17 104.44 249.49 119.23 276.48 109.43 346.56 137 367.95 130.06 232.73 15.57 213.17 27.07 184.02 0 183.94 0 154.78 27.07 135.22 15.57 0 130.06 21.35 137 91.47 109.43 118.46 119.23 154.78 104.44 183.94 130.54 184.02 130.54"/>
			</g>
		</svg>
		<svg class="svg-text subtitle" width="0" height="0" data-name="text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 828.79 107.83">
			<defs></defs>
			<title>Phantom Equipment</title>
			<g id="text" data-name="text">
				<path d="M226.09,545.19h69.6a42.77,42.77,0,0,1,12.76,1.65,23.1,23.1,0,0,1,8.46,4.52,16.78,16.78,0,0,1,4.68,6.65,22.42,22.42,0,0,1,1.44,8c0,.11,0,2.7,0,2.81a22.6,22.6,0,0,1-1.43,7.82,16.36,16.36,0,0,1-4.68,6.59,23.56,23.56,0,0,1-8.46,4.47,42.7,42.7,0,0,1-12.76,1.65H245.77v15.38H226.09Zm19.68,17v10.15h49.39a26.52,26.52,0,0,0,4.36-.27,4.63,4.63,0,0,0,2.13-.8,2,2,0,0,0,.74-1.22,10.13,10.13,0,0,0,.11-1.38c0-.05,0-2.6,0-2.65a10.74,10.74,0,0,0-.11-1.49,1.81,1.81,0,0,0-.74-1.22,5.67,5.67,0,0,0-2.13-.8,22.3,22.3,0,0,0-4.36-.32Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M420.13,583.48H359.85v21.27H340.17V545.19h19.68v21.27h60.28V545.19h19.68v59.56H420.13Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M542,595.4H487.88l-7.45,9.36H456.29l48.39-59.56h20.74l48.39,59.56H549.57Zm-42.22-14.78h30.31L515,561.36Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M670.55,604.76l-59.88-37.55v37.55H591V545.19h18.61l60,37.65V545.19h19.57v59.56Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M706.26,545.19h98.17v17H765.57v42.54H745.89V562.21H706.26Z" transform="translate(-225.61 -544.34)"/>
				<path d="M857.79,605.61a63.4,63.4,0,0,1-18.72-2.39,34.43,34.43,0,0,1-12.44-6.54,24.12,24.12,0,0,1-6.91-9.73,34.72,34.72,0,0,1,0-23.93,24.11,24.11,0,0,1,6.91-9.73,34.42,34.42,0,0,1,12.44-6.54,63.4,63.4,0,0,1,18.72-2.39h29.67a63.42,63.42,0,0,1,18.72,2.39,33.87,33.87,0,0,1,12.39,6.54,24.35,24.35,0,0,1,6.86,9.73,34.72,34.72,0,0,1,0,23.93,24.36,24.36,0,0,1-6.86,9.73,33.88,33.88,0,0,1-12.39,6.54,63.42,63.42,0,0,1-18.72,2.39Zm29.57-16.91a38.36,38.36,0,0,0,10-1.06,15,15,0,0,0,5.9-2.87,9.05,9.05,0,0,0,2.82-4.36,19.31,19.31,0,0,0,.74-5.42,18.77,18.77,0,0,0-.74-5.37,9.08,9.08,0,0,0-2.82-4.31,15.06,15.06,0,0,0-5.9-2.87,38.5,38.5,0,0,0-10-1.06H857.9a39.65,39.65,0,0,0-10.16,1.06,15.08,15.08,0,0,0-6,2.87A8.73,8.73,0,0,0,839,569.6a20.07,20.07,0,0,0-.69,5.37,20.66,20.66,0,0,0,.69,5.42,8.71,8.71,0,0,0,2.77,4.36,15,15,0,0,0,6,2.87,39.51,39.51,0,0,0,10.16,1.06Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M1054.39,545.19v59.56h-19.68V571L998.45,603.8,962.39,571v33.72H942.72V545.19h18.72l37,33.08,37-33.08Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M225.61,626.26h32v3.52h-28.1v6.08h24.83v3.2H229.48v6.08h28.1v3.52h-32Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M339,649a21.48,21.48,0,0,1-6.67-.91,12.66,12.66,0,0,1-4.51-2.46,9.24,9.24,0,0,1-2.54-3.65,13,13,0,0,1,0-9,9.25,9.25,0,0,1,2.54-3.65,12.63,12.63,0,0,1,4.51-2.46,21.45,21.45,0,0,1,6.67-.91h9.34a21.45,21.45,0,0,1,6.67.91,12.64,12.64,0,0,1,4.51,2.46,9.25,9.25,0,0,1,2.54,3.65,12.51,12.51,0,0,1,.8,4.5,13,13,0,0,1-.37,3.12,10.27,10.27,0,0,1-1.14,2.78,9.57,9.57,0,0,1-2,2.35,11.38,11.38,0,0,1-2.88,1.79l8.7,4.67h-6.53l-6.37-3.49a25.57,25.57,0,0,1-4,.29Zm9.31-3.52a16.93,16.93,0,0,0,5-.62,8.6,8.6,0,0,0,3.22-1.71,6.09,6.09,0,0,0,1.73-2.54,9.77,9.77,0,0,0,0-6.24,6.1,6.1,0,0,0-1.73-2.54,8.62,8.62,0,0,0-3.22-1.71,16.93,16.93,0,0,0-5-.62H339a16.94,16.94,0,0,0-5,.62,8.6,8.6,0,0,0-3.22,1.71,6.09,6.09,0,0,0-1.73,2.54,9.77,9.77,0,0,0,0,6.24,6.07,6.07,0,0,0,1.73,2.54,8.6,8.6,0,0,0,3.2,1.71,16.78,16.78,0,0,0,5,.62Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M434.76,641.2a5.1,5.1,0,0,0,1.55,2.26,7.77,7.77,0,0,0,3,1.47,17.41,17.41,0,0,0,4.67.53h7.33a17.42,17.42,0,0,0,4.67-.53,7.78,7.78,0,0,0,3-1.47,5.1,5.1,0,0,0,1.55-2.26,8.85,8.85,0,0,0,.45-2.88V626.26h3.87v12.06a13.15,13.15,0,0,1-.67,4.27,7.84,7.84,0,0,1-2.26,3.38,11.12,11.12,0,0,1-4.16,2.21,21.82,21.82,0,0,1-6.38.8h-7.39a21.81,21.81,0,0,1-6.38-.8,11.12,11.12,0,0,1-4.16-2.21,7.83,7.83,0,0,1-2.26-3.38,13.13,13.13,0,0,1-.67-4.27V626.26h3.87v12.06A8.85,8.85,0,0,0,434.76,641.2Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M533.86,626.26h3.87v22.4h-3.87Z" transform="translate(-225.61 -544.34)"/>
				<path d="M607.46,626.26h24.38a13.59,13.59,0,0,1,4.16.56,7.55,7.55,0,0,1,2.8,1.54,5.89,5.89,0,0,1,1.57,2.27,7.69,7.69,0,0,1,.5,2.77,7.78,7.78,0,0,1-.5,2.8,5.76,5.76,0,0,1-1.57,2.26A7.52,7.52,0,0,1,636,640a13.94,13.94,0,0,1-4.16.54H611.33v8.16h-3.87Zm3.87,3.52V637h20.42a9.28,9.28,0,0,0,2.45-.27,4.12,4.12,0,0,0,1.55-.75,2.64,2.64,0,0,0,.82-1.14,4.11,4.11,0,0,0,.24-1.42,4,4,0,0,0-.24-1.39,2.76,2.76,0,0,0-.82-1.15,4.14,4.14,0,0,0-1.55-.78,8.79,8.79,0,0,0-2.45-.29Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M746.41,626.26v22.4h-3.87V631.6l-15.46,16.26L711.59,631.6v17.06h-3.87v-22.4h3.71l15.65,16.32,15.62-16.32Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M816.13,626.26h32v3.52H820v6.08h24.83v3.2H820v6.08h28.1v3.52h-32Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M920.36,630.8v17.86h-3.87v-22.4h3.68l26.53,17.86V626.26h3.87v22.4h-3.68Z"
							transform="translate(-225.61 -544.34)"/>
				<path d="M1017.35,626.26h36v3.52h-16.06v18.88h-3.9V629.78h-16.06Z" transform="translate(-225.61 -544.34)"/>
			</g>
		</svg>
	</div>
</template>

<script>
  export default {
    name: 'logo',
    props: ['active'],
    data () {
      return {}
    },
    methods: {
      isActive: function () {
        return this.active === 1 || this.active === 5
      },
			goTop: function () {
				window.scrollTo(0, 0);
      }
    }
  }
</script>

<style scoped>

	.text-header {
		color:  #1a1a1a;
		font-size: 32px;
		font-weight: 400;
		text-align: center;
		line-height: 23.25px;
		margin-bottom: 19px;
	}

	.logo-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		width: 100%;
		opacity: 1;
		cursor: pointer;
	}

	.hidden {
		opacity: 0;
		z-index: -1;
	}

	.svg-text {
		margin-top: 14px;
		width: 238px;
		height: 20px;
		fill: #000;
	}

	.subtitle {
	}

	.subtitleFade {
		opacity: 1;
	}


	.svg-logo {
		width: 157px;
		height: 20px;
		fill: #000;
	}

</style>



// WEBPACK FOOTER //
// src/components/blackLogo.vue?61f8d505